import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, initialSale } from './SalesUIHelpers';

const SalesUIContext = createContext();

export function useSalesUIContext() {
  return useContext(SalesUIContext);
}

export const SaleUIConsumer = SalesUIContext.Consumer;

export function SalesUIProvider({ SalesUIEvents, children }) {
  const [createdSale, setCreatedSaleBase] = useState(initialSale);
  const [saleForView, setSaleForViewBase] = useState(initialSale);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
      console.log('SalesUIProvider.setQueryParams', queryParams);
    },
    [queryParams]
  );

  const setCreatedSale = useCallback((nextCreatedSale) => {
    setCreatedSaleBase((prevCreatedSale) => {
      if (isFunction(nextCreatedSale)) {
        nextCreatedSale = nextCreatedSale(prevCreatedSale);
      }
      if (isEqual(prevCreatedSale, nextCreatedSale)) {
        return prevCreatedSale;
      }
      return nextCreatedSale;
    });
  }, []);

  const setSaleForView = useCallback((nextSaleForView) => {
    setSaleForViewBase((prevSaleForView) => {
      if (isFunction(nextSaleForView)) {
        nextSaleForView = nextSaleForView(prevSaleForView);
      }
      if (isEqual(prevSaleForView, nextSaleForView)) {
        return prevSaleForView;
      }
      return nextSaleForView;
    });
  }, []);

  const value = {
    queryParams,
    createdSale,
    saleForView,
    setQueryParams,
    setCreatedSale,
    setSaleForView,
    initialSale,
    openViewSaleDialog: SalesUIEvents.openViewSaleDialog,
    openCreateSaleDialog: SalesUIEvents.openCreateSaleDialog,
    openDeleteSaleDialog: SalesUIEvents.openDeleteSaleDialog,
  };

  return (
    <SalesUIContext.Provider value={value}>{children}</SalesUIContext.Provider>
  );
}
